import { IssueAverageAgeReportResult } from '@tap/data-providers';
import { XGridTableWrap } from '@tap/mui-ui';
import { dateTimeHelper } from '@tap/utils';

/* Таблица Средняя длительность незавершённых заявок
*/


type AverageAgeTableProps = {
    reportData: IssueAverageAgeReportResult[],
}

export default function AverageAgeTable({ reportData }: AverageAgeTableProps) {

    return (
        <XGridTableWrap
            rows={reportData.map(row => ({ ...row, id: row.date }))}
            dataIsLoading={false}
            tableHeight={'calc(100vh - 160px)'}
            tableWidth={'90%'}
            columns={[
                {
                    field: 'date',
                    headerName: 'Дата',
                    sortable: false,
                    type: 'date',
                    flex: 1,
                    renderCell: cellParams => dateTimeHelper.formatDate(new Date(cellParams.row.date), 'dd MMMM yyyy'),
                    valueGetter: value => new Date(value),
                },
                {
                    field: 'tasksCount',
                    headerName: 'Незавершённые заявки',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                },
                {
                    field: 'avgTime',
                    headerName: 'Средняя длительность незавершённых заявок, дн.',
                    sortable: false,
                    filterable: false,
                    type: 'number',
                    flex: 1,
                },
                {
                    field: 'avgTimeForFilter',
                    headerName: 'Среднее количество дней',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                    hide: true,
                    valueGetter: cellParams => cellParams.row.avgTime,
                },
            ]}

        />
    );
}

